import { Grid, Stack, Typography } from '@mui/material';
import React from 'react';
import AnalyticsCard from './Components/AnalyticsCard';
import { useState } from 'react';
import appapi from '../../../api/apiClient';
import { useEffect } from 'react';
import Layout from '../../../components/Layout';
import { useNavigate } from 'react-router-dom';
import { CancelToken } from 'apisauce';

export default function Analytics() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  let source = CancelToken.source();

  useEffect(() => {
    getData();
    return () => {
      if(source) {
        source.cancel();
      }
    }
  }, []);

  const getData = async () => {
    // dispatch(setLoading(true));
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(`analytics`,{},{
      cancelToken: source.token
    });
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setData(data?.response);
        // dispatch(setLoading(false));
      }
    } else {
    }
  };
  return (
    <Layout>
      <Stack
        style={{ backgroundColor: '#F7F7F7' }}
        flex={1}
        className="h-[100%]"
      >
        <Stack
          className="m-h-[60%]"
          style={{ backgroundColor: 'white', margin: '8px', padding: '16px' }}
        >
          <Stack style={{ marginLeft: '20px', marginBottom: '24px' }}>
            <Typography
              style={{ color: '#14285A' }}
              className="ff-Roboto fw-medium fs-16"
            >
              DASHBOARD
            </Typography>
          </Stack>
          <Grid container spacing={2}>
            {data?.map((item, index) => (
              <Grid item xs={4} key={index}>
                <AnalyticsCard
                  data={item}
                  type={index === 0 ? 1 : 2}
                  index={index}
                  onClick={() => {
                    index <= 2 ? navigate('companyManagement', { state: { index: 2 } }) : index <= 5 ? navigate('trader') : navigate('verifier');
                  }}
                />
              </Grid>
            ))}

          </Grid>
        </Stack>
      </Stack>
    </Layout>
  );
}
